import { render, staticRenderFns } from "./create-test-success.vue?vue&type=template&id=01c2e747&scoped=true"
import script from "./create-test-success.vue?vue&type=script&lang=js"
export * from "./create-test-success.vue?vue&type=script&lang=js"
import style0 from "./create-test-success.vue?vue&type=style&index=0&id=01c2e747&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2e747",
  null
  
)

export default component.exports